define('shared/initializer/form/adapters/mixins/Submittable',['shared/lib/RSVP'], 
function (RSVP) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doSubmit = function() {
        var me = this;
        var $form = me.$form;

        if (!me._blockCount || me._blockCount <= 1) {
        	$form[0].submit();
        }
    
        return RSVP.resolve();
    };

    return Ctor;
});
